const {
  API_URL,
  APP_URL,
  APP_NAME,
  APP_SUPPORT_EMAIL,
  SENTRY_DSN,
  ENV_NAME,
  GOOGLE_API_KEY,
} = window.__ENV__ || {};

export {
  API_URL,
  APP_URL,
  APP_NAME,
  APP_SUPPORT_EMAIL,
  SENTRY_DSN,
  ENV_NAME,
  GOOGLE_API_KEY,
};
